import {useCallback} from 'react';

import {useReadOnlyDataHook} from 'src/hooks/use-read-only-data-hook';
import {hubspotCredentialsCheck} from 'src/openapi/admin/apis/HubspotControllerApi';
import {useAppDispatch} from 'src/store/hooks';

type Props = {
    accountId: number,
};

export const useHubspotTestConnection = ({accountId}: Props) => {
    const apiDispatch = useAppDispatch();

    const getDispatchAction = useCallback(() => apiDispatch(
        hubspotCredentialsCheck({accountId}),
    ), [apiDispatch, accountId]);

    return useReadOnlyDataHook({
        getDispatchAction,
        initValue: {
            status: {
                crmUserInfo: {
                    orgId: '',
                },
                successful: false,
                message: '',
            },
            savedOrgId: '',
            accountsWithIdenticalOrgId: [],
        },
    });
};
